import { render, staticRenderFns } from "./EditPersonalInfoModal.vue?vue&type=template&id=0c304bd4&scoped=true"
import script from "./EditPersonalInfoModal.vue?vue&type=script&lang=ts"
export * from "./EditPersonalInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c304bd4",
  null
  
)

export default component.exports